import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { openInNewTab } from "../helpers/commonHelper";
import { useDispatch } from "react-redux";
import { SubmitContactForm } from "../actions/commonAction";

const formSchema = z.object({
  Name: z.string().min(2, "Name must contain at least 2 characters").max(50),
  PhoneNumber: z.string().optional(),
  Email: z.string().email(),
  Company: z.string().optional(),
  Subject: z.string().optional(),
  Message: z.string().min(5, "Message must contain at least 5 characters"),
});
const ContactUs = () => {
  const dispatch = useDispatch();
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      Name: "",
      PhoneNumber: "",
      Email: "",
      Company: "",
      Subject: "",
      Message: "",
    },
  });

  function onSubmit(obj) {
    dispatch(SubmitContactForm(obj, () => {
      form.reset();
    }))
  }
  return (
    <div className="container m-auto p-4 md:py-6">
      <h2 className="text-2xl font-semibold mb-1 leading-loose">
        Need Help? Contact Us
      </h2>
      <div className="grid grid-cols-3 gap-6">
        <div className="col-span-2">
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <FormField
                  control={form.control}
                  name="Name"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Name *</FormLabel>
                      <FormControl>
                        <Input placeholder="Full Name" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="PhoneNumber"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Phone Number</FormLabel>
                      <FormControl>
                        <Input placeholder="+977" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
              {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6"> */}
              <FormField
                control={form.control}
                name="Email"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Email *</FormLabel>
                    <FormControl>
                      <Input type="email" placeholder="example@mail.com" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              {/* <FormField
                  control={form.control}
                  name="Company"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Company</FormLabel>
                      <FormControl>
                        <Input placeholder="Company Name" {...field} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                /> */}
              {/* </div> */}
              <FormField
                control={form.control}
                name="Subject"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Subject</FormLabel>
                    <FormControl>
                      <Input placeholder="Describe your request" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="Message"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Message *</FormLabel>
                    <FormControl>
                      <Textarea
                        placeholder="Write down your message"
                        className="resize-none h-32"
                        {...field}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <div className="space-y-4 pt-2">
                <p className="text-sm text-gray-500 flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 text-[#ea580c]">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clipRule="evenodd" />
                  </svg>
                  We typically respond within a business day.
                </p>
                <Button type="submit">
                  Send Message
                </Button>
              </div>
            </form>
          </Form>
        </div>
        <div>
          <div>
            <h2 className="text-lg font-semibold mb-0 leading-loose">
              Address
            </h2>
            <p className="mb-3">
              5th Floor Kamaladi Complex, Kamaladi Kathmandu</p>
          </div>
          <div>
            <h2 className="text-lg font-semibold mb-0 leading-loose">Phone</h2>
            <p className="mb-3">
              (+977) 01-5971312 <br />
              (+977) 9767996761 <br />
            </p>

          </div>
          <div>
            <h2 className="text-lg font-semibold mb-0 leading-loose">Mail</h2>
            <p className="mb-3">
              <a target="_blank" href="/mailto: tickets@yatratickets.com">
                tickets@yatratickets.com
              </a>
            </p>
          </div>
          <div>
            <h2 className="text-lg font-semibold mb-0 leading-loose">
              Opening hour
            </h2>
            <p className="mb-3">
              Sunday to Friday <br />
              9:00am to 6:00pm
            </p>
          </div>
          <div className="relative">
            {/* <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d113033.75146406019!2d85.31844!3d27.707876!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb1900d1508d0d%3A0x240039790af486fd!2sGandaki%20Tours%20%26%20Travels%20Pvt.%20Ltd.!5e0!3m2!1sen!2snp!4v1716027536930!5m2!1sen!2snp&z=50"
              width="440px"
              height="300px"

              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe> */}

            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3334.0405141430047!2d85.31763684393404!3d27.708232327364154!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb1900d1508d0d%3A0x240039790af486fd!2sGandaki%20Tours%20%26%20Travels%20Pvt.%20Ltd.!5e0!3m2!1sen!2snp!4v1723483273945!5m2!1sen!2snp"
              width="440px"
              height="300px"
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade">

            </iframe>
            {/* <div className="absolute -translate-x-1/2 -translate-y-1/2 left-2/4 top-2/4">
              <Button
                className="bg-primary"
                onClick={() => {
                  openInNewTab(
                    "https://www.google.com/maps?ll=27.707837,85.318561&z=11&t=m&hl=en&gl=NP&mapclient=embed&cid=2594136577403029245"
                  );
                }}
              >
                Get Direction
              </Button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
